import styled from 'styled-components';

export const NavEl = styled.nav`
  display: flex;
  @media (min-width: 1280px) {
    justify-content: space-between;
    width: 100%;
  }
`;

export const Button = styled.button`
  background-color: transparent;
  border: 1px transparent solid;
`;
